module.exports = __webpack_public_path__ + "img/rating.31e5858c.png";